export const PRODUCT_ID = 'productId';
